import { FC, createContext, ReactNode, useReducer, useMemo } from 'react';
import { GlobalConfiguration, GlobalConfigurationInitial, ConfigurationData } from './state';
import { globalConfigurationReducer } from './reducer';
import { ConfigurationKeys } from '@/shared/common/enums';
import { buildApiUrl } from '@/global.ts';
import { setConfigurationAction } from './actions';

interface ConfigurationContextProps extends GlobalConfiguration {
  consoleLog: () => void;
  setConfiguration: () => void;
  getConfigValue: (key: string) => string;
  getConfigVariant1: (key: string) => string;
  getConfigVariant2: (key: string) => string;
  getConfigVariant3: (key: string) => string;
  getConfigVariant4: (key: string) => string;
  getConfigVariant5: (key: string) => string;
}

export const ConfigurationContext = createContext<ConfigurationContextProps>({
  ...GlobalConfigurationInitial,
  consoleLog: () => {},
  setConfiguration: () => {},
  getConfigValue: (key: string) => {
    return key;
  },
  getConfigVariant1: (key: string) => {
    return key;
  },
  getConfigVariant2: (key: string) => {
    return key;
  },
  getConfigVariant3: (key: string) => {
    return key;
  },
  getConfigVariant4: (key: string) => {
    return key;
  },
  getConfigVariant5: (key: string) => {
    return key;
  },
});

interface ConfigurationProviderProps {
  children: ReactNode;
}

interface ConfigurationResponse {
  lista: Array<ConfigurationData>;
  resultado: boolean;
}

export const ConfigurationProvider: FC<ConfigurationProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(globalConfigurationReducer, GlobalConfigurationInitial);
  // const [configMap, setConfigMap] = useState<Record<string, ConfigurationData>>(
  //   {} as Record<string, ConfigurationData>
  // );

  const consoleLog = async () => {
    console.log('contexto');
  };

  const setConfiguration = async () => {
    try {
      const response = await fetch(buildApiUrl('/General/obten-configuracion'), {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) throw Error('Error al obtener los datos');

      const result: ConfigurationResponse = await response.json();

      if (!result.resultado) throw Error('Error al obtener el objeto');

      dispatch(setConfigurationAction(result.lista));
    } catch (error) {
      console.log(error);
    }
  };

  const getConfigValue = (key: string): string => {
    const config = getConfiguration(key);
    return config.v;
  };
  const getConfigVariant1 = (key: string): string => {
    const config = getConfiguration(key);
    return config.v1;
  };
  const getConfigVariant2 = (key: string): string => {
    const config = getConfiguration(key);
    return config.v2;
  };
  const getConfigVariant3 = (key: string): string => {
    const config = getConfiguration(key);
    return config.v3;
  };
  const getConfigVariant4 = (key: string): string => {
    const config = getConfiguration(key);
    return config.v4;
  };
  const getConfigVariant5 = (key: string): string => {
    const config = getConfiguration(key);
    return config.v5;
  };

  const configMap = useMemo(() => {
    return state.configuration.reduce(
      (acc, item) => {
        acc[item.c] = item;
        return acc;
      },
      {} as Record<string, ConfigurationData>
    );
  }, [state.configuration]);

  const getConfiguration = (key: string): ConfigurationData => {
    return configMap[key] ?? ({} as ConfigurationData);
  };

  return (
    <ConfigurationContext.Provider
      value={{
        ...state,
        consoleLog,
        setConfiguration,
        getConfigValue,
        getConfigVariant1,
        getConfigVariant2,
        getConfigVariant3,
        getConfigVariant4,
        getConfigVariant5,
      }}
    >
      {children}
    </ConfigurationContext.Provider>
  );
};

export { ConfigurationKeys };
